import { useTranslation } from 'react-i18next';
import myImage12 from '../image/12.jpg';
import myImage13 from '../image/13.jpg';
import myImage14 from '../image/14.jpg';
import myImage15 from '../image/15.jpg';
import myImage16 from '../image/16.jpg';
import myImage04 from "@/pages/home/image/04.jpg";

export default function Partners() {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const partners = [
    {
      id: 1,
      nameKey: 'partner_1_name',
      descKey: 'partner_1_desc',
      image: myImage12,
    },
    {
      id: 2,
      nameKey: 'partner_2_name',
      descKey: 'partner_2_desc',
      image: myImage13,
    },
    {
      id: 3,
      nameKey: 'partner_3_name',
      descKey: 'partner_3_desc',
      image: myImage14,
    },
    {
      id: 4,
      nameKey: 'partner_4_name',
      descKey: 'partner_4_desc',
      image: myImage15,
    },
    {
      id: 5,
      nameKey: 'partner_5_name',
      descKey: 'partner_5_desc',
      image: myImage16,
    },
  ];

  return (
    <section id="partners" className="py-20 sm:py-32 bg-[#2a1f14]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6 mb-12 sm:mb-16">
          <div className="inline-block border border-[#c9a96e]/50 rounded-full px-5 py-2 self-start">
            <span className="text-sm font-medium text-[#c9a96e] whitespace-nowrap">{t('partners_badge')}</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-[#f5ede0] leading-tight sm:max-w-2xl sm:text-right">
            {t('partners_title_1')}
            <br />
            {t('partners_title_2')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-8">
          {partners.map((partner) => (
            <div key={partner.id} className="group cursor-pointer">
              <div className="bg-[#f5ede0] rounded-xl sm:rounded-2xl overflow-hidden mb-3 sm:mb-4 transition-transform duration-300 group-hover:scale-105">
                <div className="w-full h-[160px] sm:h-[240px] lg:h-[280px]">
                  <img
                    src={partner.image}
                    alt={t(partner.nameKey)}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-1">
                <h3 className="text-sm sm:text-base font-semibold text-[#f5ede0]">{t(partner.nameKey)}</h3>
                <p className="text-xs sm:text-sm text-[#c9a96e]">{t(partner.descKey)}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-20 text-center">
          <p className="text-base sm:text-xl text-[#c9a96e] mb-6 sm:mb-8 leading-relaxed max-w-3xl mx-auto">
            {t('partners_desc')}
          </p>
          <button
            onClick={scrollToContact}
            className="bg-[#c9a96e] text-[#2a1f14] px-8 sm:px-10 py-3 sm:py-4 rounded-lg font-medium hover:bg-[#b8864e] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base">
            {t('partners_cta')}
          </button>
        </div>
      </div>
    </section>
  );
}
